import React from 'react'
import update from 'immutability-helper';

import { phoneNumberFormatter } from '../../helpers/General/PhoneNunberFormatter'
import { lead } from '../../core/controllers/Lead';
import { modal } from '../../core/utilities/modal'

export default class LeadEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leadId : props.leadId,
            leadData: {
                lead_phone: '',
                lead_firstname: '',
                lead_lastname: '',
                lead_score: 1,
                screen_request_token: null,
                lead_email: '',
                emailLead: false
            },
            screened: false,
            screeningData: null,
            screeningAttachments: null
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newLead){
            lead.setLeadId(this.state.leadId);
            lead.getLead(function(response) {
                if (response.data != null) {
                    self.setState({
                        leadData: response.data.lead,
                        screeningData: response.data.screeningData,
                        screeningAttachments: response.data.screeningAttachments
                    });
                }
            });
        } else {
            lead.setLeadId(0);
        }

        var self = this;
        jQuery(".toggle-switch").bootstrapToggle();
        jQuery(".toggle-switch").change(function(e){
            const value = jQuery(e.target).prop('checked');
            if (value) {
                modal.showInfo("This will email the lead a background screen request!", "warning", "top", "center");
            }

            self.setState({
                leadData: update(self.state.leadData, {
                    emailLead: {$set: value
                    }}
                )
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {}

    handleFirstnameChange(e){
        this.setState({
            leadData: update(this.state.leadData, {
                lead_firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            leadData: update(this.state.leadData, {
                lead_lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            leadData: update(this.state.leadData, {
                lead_email: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            leadData: update(this.state.leadData, {
                lead_phone: {$set: phoneNumber
                }}
            )
        });
    }

    validate() {
        const enteredData = this.state.leadData;
        const email = enteredData.lead_email;
        const firstname = enteredData.lead_firstname;
        const lastname = enteredData.lead_lastname;
        const phonenumber = enteredData.lead_phone;

        if(firstname === undefined || firstname.length == 0) {
            modal.showInfo("You need to enter the lead's firstname.", "warning", "top", "center");
            return false;
        }

        if(lastname === undefined || lastname.length == 0) {
            modal.showInfo("You need to enter the lead's lastname.", "warning", "top", "center");
            return false;
        }

        if(email === undefined || email.length == 0) {
            modal.showInfo("You need to enter the lead's email.", "warning", "top", "center");
            return false;
        }

        if(email && email.length > 0) {
            const lastAtPos = email.lastIndexOf('@');
            const lastDotPos = email.lastIndexOf('.');
            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                modal.showInfo("Email is invalid.", "danger", "top", "center");
                return false;
            }
        }

        if(phonenumber === undefined || phonenumber.length == 0) {
            modal.showInfo("You need to enter the lead's phone number.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    sendScreeningRequest() {
        var self = this;
        if(!this.validate()) {
            return;
        }

        lead.sendScreeningRequest(function(response) {
            if(response.status && response.status == 'OK') {
                lead.getLead(function(response) {
                    self.setState({
                        leadData: response.data.lead,
                        screeningData: response.data.screeningData,
                        screeningAttachments: response.data.screeningAttachments
                    });
                });
                modal.showInfo("Background screen request sent!", "success", "top", "center");
            }
        });
    }

    handleSaveLead(e){
        var self = this;
        if(!this.validate()) {
            return;
        }

        lead.saveLead(this.state.leadData, function(response) {
            if(response.status && response.status == 'OK') {
                if (self.props.newLead) {
                    modal.showInfo("Lead was created!", "success", "top", "center");
                    self.setState({
                        leadData: {
                            lead_phone: '',
                            lead_firstname: '',
                            lead_lastname: '',
                            lead_score: 1,
                            lead_email: '',
                            emailLead: false
                        }
                    })
                } else {
                    modal.showInfo("Lead was updated!", "success", "top", "center");
                }
            }
        });
    }

    handleDeleteLead(){
        lead.deleteLead(this.props.leadId);
    }

    handleLeadScoreChange(e) {
        this.setState({
            leadData: update(this.state.leadData, {
                lead_score: {$set: e.target.value
                }}
            )
        });
    }

    render(){
        const emailLead = this.state.leadData.emailLead;
        const newLead = this.props.newLead;
        const screened = this.state.screened;
        const screeningData = this.state.screeningData;
        const screeningAttachments = this.state.screeningAttachments;
        var leadData = this.state.leadData;

        const screenRequestSent = leadData.screen_request_token;
        return (
            <div>
            <div class="row blue-bottom-margin">
                {newLead ? (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">Add a Lead</span>
                        </div>
                    </div>
                </div>
                ) : (
                <div class="row">
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{leadData.lead_firstname} {leadData.lead_lastname}</span>
                        </div>
                    </div>
                </div>
                )}
                <div class="col-md-8">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Lead Information</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <form>
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <input type="text" class="form-control tenant-info" name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)} value={leadData.lead_firstname}/>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="lastname">Last Name</label>
                                            <input type="text" class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" onChange={this.handleLastnameChange.bind(this)} value={leadData.lead_lastname}/>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input type="text" class="form-control tenant-info" name="email" placeholder="Email" id="email" onChange={this.handleEmailChange.bind(this)} value={leadData.lead_email}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="phone">Primary Phone</label>
                                            <input type="text" class="form-control tenant-info" value={leadData.lead_phone} name="primaryphone" placeholder="Phone" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                    </div>
                                    { newLead && (
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label for="email_tenant">Email Screen Request</label>
                                            <br/>
                                            <input type="checkbox" class="toggle-switch" id="email_tenant" defaultChecked={emailLead} data-toggle="toggle"/>
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card">
                        <div class="header red-header">
                            <h2 class="title text-center">
                            <div class="col-md-12"><i class="pe-7s-medal"></i> Lead Score</div>
                            </h2>
                        </div>
                        <div class="content">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="qualityscore"></label>
                                        <select class="form-control" value={leadData.lead_score} onChange={this.handleLeadScoreChange.bind(this)}>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { !newLead && (
                <div class="col-md-4">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Background Screening</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="row">
                                {!screened && screeningData != null ? (
                                    screeningData.order_status === 'Ready' ? (
                                        <a target="_blank" href={screeningAttachments ? screeningAttachments[0].url : ''}>
                                            <button type="button" id="see-results" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill center-block" autoComplete="off">
                                                See Results
                                            </button>
                                        </a>
                                    ) : (
                                        <div class="col-md-10">Order Status: {screeningData.order_status}</div>
                                    )
                                ) : (
                                    screenRequestSent != null ? (
                                        <button type="button" id="resend-screen" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill center-block" autoComplete="off" onClick={this.sendScreeningRequest.bind(this)}>
                                            Re-send Background Screen Request
                                        </button>
                                    ) : (
                                        <button type="button" id="email-screen" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill center-block" autoComplete="off" onClick={this.sendScreeningRequest.bind(this)}>
                                            Email Background Screen Request
                                        </button>
                                    )
                                )}
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            <div class="row blue-bottom">
                <div class="blue-bottom-center-align">
                    { newLead ? (
                        <div class="col-md-12">
                            <button type="button" id="create-lead" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveLead.bind(this)}>
                            Create Lead
                            </button>
                        </div>
                    ) : (
                        <div>
                            <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                                <button type="button" id="delete-lead" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteLead.bind(this)}>
                                    Delete Lead
                                </button>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <button type="button" id="update-lead" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveLead.bind(this)}>
                                    Update Lead
                                </button>
                            </div>
                        </div>
                    )}
                    <div class="clearfix"></div>
                </div>
            </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Lead/LeadEdit.jsx